import { apiFetch } from "./client";

export interface Merchant {
  id: string;
  name: string;
  email: string;
  slug: string;
  defaultCountry: string;
  status?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface MerchantList {
  data: Merchant[];
  nextCursor?: string | null;
}

export interface CreateMerchantInput {
  name: string;
  email: string;
  defaultCountry: string;
  slug?: string;
}

export interface UpdateMerchantInput {
  name?: string;
  email?: string;
  defaultCountry?: string;
  status?: string;
}

export const listMerchants = (params: { limit?: number; cursor?: string } = {}) =>
  apiFetch<MerchantList>("/admin/merchants", {
    query: { limit: params.limit, cursor: params.cursor },
  });

export const getMerchant = (id: string) => apiFetch<Merchant>(`/admin/merchants/${id}`);

export const createMerchant = (body: CreateMerchantInput) =>
  apiFetch<Merchant>("/admin/merchants", { method: "POST", body });

export const updateMerchant = (id: string, body: UpdateMerchantInput) =>
  apiFetch<Merchant>(`/admin/merchants/${id}`, { method: "PATCH", body });
